import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createRdo } from "@/adapters/api";
import { toRdo } from "../utils/map.ts";
import { rdoQueryKey } from "./use-rdo.ts";
import { rdosQueryKey } from "./use-rdos.ts";

export function useCreateRdo(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (reportDate: string) => {
			if (!constructionId) throw new Error("missing construction");
			return toRdo(await createRdo(constructionId, { reportDate }));
		},
		onSuccess: (rdo) => {
			queryClient.setQueryData(rdoQueryKey(constructionId, rdo.id), rdo);
			queryClient.invalidateQueries({ queryKey: rdosQueryKey(constructionId) });
		},
	});
}
